import React from "react";
import { motion } from "motion/react";

const StudentsTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="nav-tabs" style={{ position: "relative" }}>
      <button
        className={`tab-btn press-in-effect ${
          activeTab === "events" ? "active" : ""
        }`}
        onClick={() => setActiveTab("events")}
      >
        Events
        {activeTab === "events" && (
          <motion.div
            layoutId="active-student-tab-indicator"
            transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
            style={{
              position: "absolute",
              bottom: "-1px",
              left: "0",
              width: "100%",
              height: "2.5px",
              backgroundColor: "#007bff",
            }}
          />
        )}
      </button>
      <button
        className={`tab-btn press-in-effect ${
          activeTab === "students" ? "active" : ""
        }`}
        onClick={() => setActiveTab("students")}
      >
        Onboarded Students
        {activeTab === "students" && (
          <motion.div
            layoutId="active-student-tab-indicator"
            transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
            style={{
              position: "absolute",
              bottom: "-1px",
              left: "0",
              width: "100%",
              height: "3px",
              backgroundColor: "#007bff",
            }}
          />
        )}
      </button>
    </div>
  );
};

export default StudentsTabs;
